import { heroHighlights } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div
        className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-primary-100/70 blur-3xl"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -bottom-32 left-0 h-72 w-72 rounded-full bg-accent-100/60 blur-3xl"
        aria-hidden="true"
      />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 pb-16 pt-12 md:px-6 md:pb-24 md:pt-20 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500" aria-hidden="true" />
            图片 · 视频 · 会员福利，持续分享中
          </span>

          <h1 className="mt-5 font-heading text-3xl font-semibold leading-tight tracking-tight text-foreground-950 text-balance md:text-5xl">
            香蕉社区：把好用的图片、视频与会员福利分享给你
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这是一个围绕资源与福利的内容社区。我们把分散的图片、视频与会员分享整理成清晰的分类，帮你更快找到想看的内容，也让每一份分享都能被更多人看到。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#gallery"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              <i className="ri-image-2-line text-base" aria-hidden="true" />
              浏览图片资源
            </a>
            <a
              href="#videos"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-play-circle-line text-base" aria-hidden="true" />
              看看视频内容
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-1 gap-4 border-t border-background-200 pt-6 sm:grid-cols-3">
            {heroHighlights.map((item) => (
              <div key={item.label} className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-secondary-900">
                  <i className={`${item.icon} text-lg`} aria-hidden="true" />
                </span>
                <div>
                  <dt className="text-xs text-foreground-500">{item.label}</dt>
                  <dd className="text-sm font-medium text-foreground-950">{item.value}</dd>
                </div>
              </div>
            ))}
          </dl>
        </Reveal>

        <Reveal delay={120} className="relative">
          <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20cozy%20creative%20workspace%20flat%20lay%20with%20fresh%20bananas%2C%20notebook%2C%20camera%20and%20green%20plants%20on%20a%20soft%20cream%20background%2C%20cheerful%20yellow%20and%20green%20tones%2C%20clean%20minimal%20lifestyle%20photography%2C%20soft%20natural%20light%2C%20gentle%20shadows%2C%20harmonious%20balanced%20composition&width=900&height=900&seq=banana-hero-01&orientation=squarish"
              alt="香蕉社区内容分享场景：桌面上的香蕉、相机与绿植"
              title="香蕉社区 图片视频与会员福利分享"
              className="h-[320px] w-full object-cover md:h-[460px]"
            />
          </div>

          <div className="absolute -bottom-5 left-4 right-4 rounded-lg border border-background-200 bg-background-50 p-4 md:-bottom-6 md:left-6 md:right-6">
            <div className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-800">
                <i className="ri-refresh-line text-lg" aria-hidden="true" />
              </span>
              <div>
                <p className="text-sm font-medium text-foreground-950">每周持续更新</p>
                <p className="mt-0.5 text-xs leading-relaxed text-foreground-600">
                  新图片、新视频与新福利按周补充，关注即可第一时间看到。
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}